// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import useRouter from 'Hooks/useRouter';
import NotFound from 'Components/NotFound/NotFound';

const StyledNotFoundPage = styled.div`
  display: block;
`;

const NotFoundPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { query } = useRouter();
  const { bodyAttributes } = Helmet.peek() || {};

  let notFoundPageClassName = bodyAttributes?.class || '';
  if (!notFoundPageClassName.includes('NotFoundPage')) {
    notFoundPageClassName += 'NotFoundPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.dashboard') }</title>
        <body className={ notFoundPageClassName } />
      </Helmet>
      <StyledNotFoundPage theme={ theme } className="grid-container">
        <NotFound type={ query?.type } />
      </StyledNotFoundPage>
    </>
  );
});

NotFoundPage.displayName = 'NotFoundPage';

export default NotFoundPage;
